import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c4427126")

_pushScopeId("data-v-c4427126")
const _hoisted_1 = { class: "p-mb-2" }
const _hoisted_2 = { class: "p-ml-5 p-mr-5" }
const _hoisted_3 = {
  key: 0,
  class: "text text-title fontP"
}
const _hoisted_4 = {
  key: 1,
  class: "text text-title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.title == 'Simulador de TPP')
        ? (_openBlock(), _createBlock("h3", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.title != 'Simulador de TPP')
        ? (_openBlock(), _createBlock("h3", _hoisted_4, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true)
    ])
  ]))
})